import { tns } from 'tiny-slider';
import { isInViewport } from '../helpers/functions';
import { breakpoints } from '../helpers/constants';
const stickyNavigation = () => {
  const inPageNav = document.querySelector('.frame-type-sticky_inpage_nav');
  const $sections = document.querySelectorAll('.frame:not(.frame-type-sticky_inpage_nav)');
  if (!inPageNav) return;
  const inPageNavLinks = inPageNav.querySelectorAll('a[href^="#"]');
  const $inPageNavList = inPageNav.querySelector('.sticky-nav-list');
  const sliderConf = {
    mouseDrag: true,
    controls: false,
    nav: false,
    items: 3.3,
    gutter: 20,
    loop: false,
    autoplayButtonOutput: false,
    autoWidth: true,
    arrowKeys: true,
    preventScrollOnTouch: 'auto',
    responsive: {
      [breakpoints.md]: {
        gutter: 40
      },
      [breakpoints.lg]: {
        gutter: 50
      }
    }
  };
  const inPageNavSlider = tns(Object.assign(sliderConf, {
    container: $inPageNavList
  }));
  window.addEventListener('scroll', () => {
    const visibleSection = [...$sections].find($el => isInViewport($el, inPageNav.offsetHeight + 30));
    if (!visibleSection) return;
    const activeId = visibleSection.id;
    if (!activeId) return;
    inPageNavLinks.forEach($el => $el.classList.remove('active'));
    const $activeLink = inPageNav.querySelector(`a[href="#${activeId}"]`);
    if ($activeLink) {
      const {
        index
      } = $activeLink.dataset;
      inPageNavSlider.goTo(index);
      $activeLink.classList.add('active');
    }
  });
};
export default stickyNavigation;